import { OC_STATUS_KEYS, REPROCESSABLE_STATUSES } from '../constants/ocConstants'

export const canReprocessOrder = ({
  status,
  processed_lines_percentage,
  is_ignored = false
}) => {
  if (is_ignored) return false
  if (!REPROCESSABLE_STATUSES.includes(status)) return false

  // ERP insert failure: allow reprocess regardless of fill rate
  if (status === OC_STATUS_KEYS.NO_INSERTED) return true

  const percent = Number(processed_lines_percentage)

  if (Number.isNaN(percent)) return false
  if (percent === 100) return false

  return true
}
